import React from 'react';

import Button from '@sats-group/ui-lib/react/button';
import Text from '@sats-group/ui-lib/react/text';
import TextInput from '@sats-group/ui-lib/react/text-input';

import type { NamedFC } from 'shared/types/named-fc.types';

import Layout from 'ui/components/layout/layout';

import type { FriendOfStaffLanding as Props } from './friend-of-staff-landing.props';

const FriendOfStaffLanding: NamedFC<Props> = ({
  description,
  endpoint,
  input,
  layout,
  submit,
  subtitle,
}) => {
  return (
    <Layout alignTitleLeft contentWidth="narrow" {...layout}>
      <div className="friend-of-staff-landing">
        <form
          action={endpoint}
          id="employee-id-form"
          method="GET"
          className="friend-of-staff-landing__form"
        >
          <TextInput {...input} />
        </form>

        <div className="friend-of-staff-landing__description">
          <Text size="small" theme="emphasis">
            {subtitle}
          </Text>
          <Text>{description}</Text>
        </div>
      </div>

      <div className="friend-of-staff-landing__form-submit">
        <Button form="employee-id-form" wide={true} {...submit} />
      </div>
    </Layout>
  );
};

FriendOfStaffLanding.displayName = 'FriendOfStaffLanding';

export default FriendOfStaffLanding;
